<template>
  <div class="row">
    <div class="col-md-12 header-row">
      <h3 class="heading semi-bold">All Fabrics</h3>
      <div class="row">
        <div class="col-md-3">
          <div class="input-group transparent">
            <span class="input-group-addon">
              <i class="fa fa-search" aria-hidden="true"></i>
            </span>
            <input
              type="text"
              @keyup.enter="searchFabric($event.target.value)"
              class="form-control search-fabric"
              placeholder="Search Fabric"
            />
          </div>
        </div>
        <div class="col-md-9 text-right">
          <router-link
            :to="{ path: '/fabric/listing/list_view' }"
            class="btn btn-default"
          >
            <i class="fa fa-list" aria-hidden="true"></i> List View
          </router-link>
          <router-link
            :to="{ name: 'fabric_create' }"
            class="btn shadow btn-primary create-new"
            v-if="!isReadOnlyUser"
          >
            <i class="fa fa-plus-circle" aria-hidden="true"></i> Create New
            Fabric
          </router-link>
        </div>
      </div>
    </div>
    <div class="col-md-12">
      <div class="row flex">
        <div class="col-md-3" v-for="fabric in fabrics" :key="fabric.id">
          <fabric-list-card :fabric="fabric" />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import FabricListCard from "./components/FabricListCard";
export default {
  components: {
    FabricListCard,
  },
  data() {
    return {
      allData: [],
      fabrics: [],
      searchResults: [],
      isReadOnlyUser: false,
    };
  },
  async mounted() {
    this.isReadOnlyUser = this.$auth.user().role === "read_only";
    await this.getFabrics();
  },
  methods: {
    async getFabrics() {
      try {
        let response = await axios.get("/v2/fabrics", {
          params: {
            columns: "id,name,status",
            custom_fields: "images",
            relationships: "images",
            sort: "id:asc",
            per_page: 0,
          },
        });

        let collection = response.data.data.collection;

        let fabrics = collection.map((fabric) => {
          let images = fabric.images;
          if (images.length > 0) {
            // Use backend as main image
            let image = images.find((img) => {
              return img.type === "backend";
            });
            // Use the first image if the previous type is not found.
            if (!image) {
              image = images[0];
            }
            fabric["image_url"] = image.image_url;
          } else {
            fabric["image_url"] = "/assets/img/fabric-placeholder.png";
          }
          return fabric;
        });

        this.fabrics = fabrics;
        this.allData = fabrics;
      } catch (error) {
        console.log(error);
        alert("Unable to show fabrics, server error occurred.");
      }
    },

    searchFabric(search) {
      if (search != "") {
        let newArray = this.allData.filter((obj) => {
          return (
            obj.name.toLowerCase().includes(search.toLowerCase()) ||
            $Fabric.getCode(obj.id) === search
          );
        });
        this.fabrics = newArray;
      } else {
        this.fabrics = this.allData;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.header-row {
  margin-bottom: 20px;
}

.header-row .search-fabric {
  height: 38px;
}
</style>
